import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import './LoadIndicator.less';

const LoadIndicator = props => (
  <div className={classnames('loader-wrapp', { 'is-visible': props.isLoading })} >
    <div className="loader" />
  </div>
);

LoadIndicator.defaultProps = {
  isLoading: false,
};

LoadIndicator.propTypes = {
  isLoading: PropTypes.bool,
};

const mapStateToProps = ({ app }) => ({ isLoading: app.isLoading });

export default connect(mapStateToProps)(LoadIndicator);



// WEBPACK FOOTER //
// ./src/components/ui/LoadIndicator/LoadIndicator.js